import { render } from "./pageAll.vue?vue&type=template&id=4a2fa12b&scoped=true"
import script from "./pageAll.vue?vue&type=script&lang=js"
export * from "./pageAll.vue?vue&type=script&lang=js"

import "./pageAll.vue?vue&type=style&index=0&id=4a2fa12b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2fa12b"]])

export default __exports__